import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_ProductItem = _resolveComponent("ProductItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProgressBar, {
      class: _normalizeClass({'is-visible': _ctx.product.isLoading})
    }, null, 8, ["class"]),
    (_ctx.product.items)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["ProductList ProductList--col3", {'is-loading': _ctx.product.isLoading}])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.items, (productItem) => {
            return (_openBlock(), _createBlock(_component_ProductItem, {
              key: productItem.id,
              source: productItem.html
            }, null, 8, ["source"]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}